import API from "@/utils/input-output/api";

export default async function handleCacheKey() {
  await API({
    url: "deployments/recent",
    method: "get",
    initiator: "global",
    requestId: "fetchRecentDeploymentData",
    disableDefaultErrorHandlingAt: [451],
  })
    .then(({ data }) => {
      /**
       * Critical we need to enhance this code
       * check evey localstorage.clear() as no need to remove the cache key
       */

      const { cacheKey } = data.payload
      if (!cacheKey) return;

      const storedKey = localStorage.getItem("cache-key");
      if (storedKey !== cacheKey) {
        localStorage.setItem("cache-key", cacheKey);
        localStorage.removeItem("filters");
        localStorage.removeItem("selectedFiltersOptionsV2");
        window.location.reload()
      }
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.warn("Error handling cache key", error);
    })
}
